export const ERROR_ACTIONS = {
  SET_ERROR: 'setError',
  DISMISS_ERROR: 'dismissError',
  CLEAR_ERRORS: 'clearError'
} as const

export type ErrorActionsType = (typeof ERROR_ACTIONS)[keyof typeof ERROR_ACTIONS]
